<template>
    <div class="course-list">
        <div class="course-list__content">
            <div v-for="(course, index) in getLimitedCourses"
                 class="course-list__item"
                 :key="index"
            >
                <slot :course="course" :index="index" >
                    <TotemCourseItemMosaic :course="course"/>
                </slot>
            </div>
        </div>
        <TotemButton
            icon="add"
            color="primary"
            class="course-list__load-more"
            @click="loadMore"
            v-if="limit < courseList.length"
            :label="$t('General.load_more')"
        />
        <TotemBackToTop />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'course-list',
        props: {
            courseList: Array,
        },
        methods: {
            loadMore () {
                this.limit += 20
            }
        },
        computed: {
            showCourseDetails () {
                return !this.isModalOpen && !this.isContextMenuOpen
            },
            getLimitedCourses () {
                return this.courseList.filter((el, index) => index < this.limit)
            },
            ...mapGetters({
                isModalOpen: 'Watchlists/isModalOpen',
                isContextMenuOpen: 'Watchlists/getCurrentMenuOpened',
            })
        },
        data () {
            return {
                offset: 0,
                limit: 20,
                courseToNewWatchlist: null,
                modalIsOpen: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course-list {
        display: flex;
        flex-direction: column;

        &__content {
            @include course_list;
        }

        &__item {
            @include course_list_item;
        }

        &__load-more {
            align-self: center;
            margin: 30px;
        }
    }
</style>
